import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Methods from "@/pages/Methods";
import Pourquoi from "@/pages/Pourquoi";
import About from "@/pages/About";
import Zone from "@/pages/Zone";
import ZoneDepartment from "@/pages/ZoneDepartment";
import Realisations from "@/pages/Realisations";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/methodes" element={<Methods />} />
          <Route path="/pourquoi-fuitex" element={<Pourquoi />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/zone-intervention" element={<Zone />} />
          <Route path="/zone-intervention/:slug" element={<ZoneDepartment />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/mentions-legales" element={<Legal page="mentions-legales" />} />
          <Route path="/confidentialite" element={<Legal page="confidentialite" />} />
          <Route path="/cgv" element={<Legal page="cgv" />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
